import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { RootState } from 'dataStore/state'
import { useActions } from 'hooks/useActions'

import TotalBlock from './totalBlock'

import OrderTable from './ordersTable/Table'
import Filters from './ordersTable/filters'

/**
 * Главный блок заказов: сводка, фильтры, серверная таблица.
 */
const OrdersTable: FC = () => {
  const { orders } = useSelector((state: RootState) => state.orders)
  const { getAllOrderStatus } = useActions()

  useEffect(() => {
    getAllOrderStatus()
  }, [])

  return (
    <div>
      <TotalBlock />
      <Filters />
      <OrderTable orders={orders} />
    </div>
  )
}

export default OrdersTable
